export const detectives = [
    
  {
    name: "Karl Lu",
    github: "https://github.com/klukreativ",
    linkedin: "https://www.linkedin.com/in/karl-lu",
    image: "karl.jpg",
  },
  {
    name: "Paula Vivas",
    github: "https://github.com/paulavivasteixeira",
    linkedin: "https://www.linkedin.com/in/paulavivasteixeira/?locale=en_US",
    image: "paula.png",
  },
  {
    name: "Phil Miles",
    github: "https://github.com/pgm87",
    linkedin: "https://www.linkedin.com/in/philip-miles-01570b24b/",
    image: "phil.jpg",
  },
  {
    name: "Serena Kang",
    github: "https://github.com/serenakang77",
    linkedin: "https://www.linkedin.com/in/serena-kang-dev/",
    image: "serena.webp",
  },
]
